import React from "react";

function TesterCard({ stats = {} }) {
  const cards = [
    {
      title: "Assigned Projects",
      value: stats?.assignedProjects || 0,
      icon: "ti ti-clipboard-list",
      className: "stat-primary",
    },
    {
      title: "In Testing",
      value: stats?.inTestingProjects || 0,
      icon: "ti ti-test-pipe",
      className: "stat-info",
    },
    {
      title: "Open Bugs",
      value: stats?.openBugs ?? stats?.bugsFound ?? 0,
      icon: "ti ti-bug",
      className: "stat-danger",
    },
    {
      title: "Fixed Bugs",
      value: stats?.fixedBugs || 0,
      icon: "ti ti-tools",
      className: "stat-warning",
    },
    {
      title: "Approved Projects",
      value: stats?.approvedProjects || 0,
      icon: "ti ti-circle-check",
      className: "stat-success",
    },
    {
      title: "Total Projects",
      value: stats?.totalProjects || 0,
      icon: "ti ti-folders",
      className: "stat-primary",
    },
    {
      title: "Closed Bugs",
      value: stats?.closedBugs || 0,
      icon: "ti ti-checks",
      className: "stat-success",
    },
    {
      title: "Total Bugs",
      value: stats?.totalBugs || 0,
      icon: "ti ti-bug",
      className: "stat-danger",
    },
  ];

  return (
    <div className="row g-3 mb-4 modern-stat-row">
      {cards.map((card) => (
        <div className="col-xl-3 col-lg-4 col-sm-6 d-flex" key={card.title}>
          <div className={`card modern-stat-card ${card.className} flex-fill`}>
            <div className="card-body">
              <div className="stat-top">
                <div>
                  <p>{card.title}</p>

                  <h3>{card.value}</h3>
                </div>

                <div className="stat-icon">
                  <i className={card.icon} />
                </div>
              </div>

              <div className="stat-wave" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default TesterCard;
